import { useCallback } from "react";

import { useSoilSightCurrency } from "utils";

import { roundsAwayToZero } from "pages/app/scenario-analysis/utils/differenceView";

/**
 * Formats a cumulative difference. It follows the house rounding everywhere except where that would
 * print a real gap as "€0": near the crossing the exact figure is shown instead, so no cell can read as
 * nothing while the chart shades it as a loss. Sign decisions stay on the raw value, never this string.
 */
export const useDifferenceAmount = (): ((value: number) => string) => {
  const { formatCurrency, formatCmOutcome } = useSoilSightCurrency();

  return useCallback(
    (value: number) =>
      roundsAwayToZero(value) ? formatCurrency(value, { decimals: 0, signDisplay: "exceptZero" }) : formatCmOutcome(value, { signDisplay: "exceptZero" }),
    [formatCurrency, formatCmOutcome]
  );
};
